export default __webpack_public_path__ + "static/media/profile-image.99388713.jpg";